module.exports = __webpack_public_path__ + "img/xionglei.656ca550.png";